import React, { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import './style.css'
import { DOMAIN } from '../Constant.js';
import Swal from 'sweetalert2';
import axiosInstance from './axiosInstance';
import { showAlert } from "../components/AlertPopup";
import CustomListBox from '../components/CustomListBox.js';

export const Model = ({ open, handleClose, taskId, refreshData }) => {//refreshData
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: '25px',
    boxShadow: 24,
    p: 4,
  };
  const [taggerProfile, setTaggerProfile] = useState([]);
  const [reviewerProfile, setReviewerProfile] = useState([]);
  const [tagger, setTagger] = useState('');
  const [reviewer, setReviewer] = useState('');

  const handleTaggerChange = (e) => {
    const { value } = e.target;
    setTagger(value);
  };
  const handleReviewerChange = (e) => {
    const { value } = e.target;
    setReviewer(value)
  };
  
  const updateHistoricalData = (e) => {
    axiosInstance
      .put(`${DOMAIN}/api/updateprofile`, null, {
        params: {
          new_profile_id: tagger,
          new_reviewer_profile_id: reviewer,
          task_id: taskId.split('_')[0],
          old_reviewer_profile_id: taskId.split('_')[1]
        }
      }).then(result => {
        showAlert('Selected tasks reassigned successfully', 'success');
        handleClose();
        refreshData();
      }).catch(error => {
        showAlert(error.response.data.message, 'error');
      });
  };

  useEffect(() => {
    axiosInstance.get(`/getallprofile`, {
      params: {
        role_id: [3, 4]
      }
    }).then(res => {
      setTaggerProfile(res.data.filter(items => items.profile_role === 3));
      setReviewerProfile(res.data.filter(items => items.profile_role === 4));
    }).catch(error => {
      console.log(error);
    });
  }, []);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        slotProps={{
            backdrop: {
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                backdropFilter: 'blur(2px)',
                WebkitBackdropFilter: 'blur(2px)',
              },
            },
          }}
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" className="font-poppins font-medium text-[14px] leading-[100%] tracking-[0%] text-gray-main pb-1 border-b border-gray-d-200 dark:text-white dark:border-white mb-[10px]" variant="h6" component="h2">
            Select Option
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>

          </Typography>
          <div className="wrapper">
          <div className="w-[100%]">
            <div className="wrapper2 w-[100%]" id="tagUsr">
              <CustomListBox
                label="Tagger User ID"
                options={[
                  { id: '', name: 'Tagger User ID' },
                  ...taggerProfile.map((tagger) => ({
                    id: tagger.profile_id,
                    name: tagger.profile_username,
                  })),
                ]}
                selectedValue={tagger}
                onChange={handleTaggerChange}
                name="taggerId"
                placeholder="Tagger User ID"
              />
            </div>

            <div className="wrapper2 w-[100%]">
              <CustomListBox
                label="Reviewer User ID"
                options={[
                  { id: '', name: 'Reviewer User ID' },
                  ...reviewerProfile.map((reviewer) => ({
                    id: reviewer.profile_id,
                    name: reviewer.profile_username,
                  })),
                ]}
                selectedValue={reviewer}
                onChange={handleReviewerChange}
                name="reviewerId"
                placeholder="Reviewer User ID"
              />
            </div>
          </div>

          <div className="wrapper flex justify-center">
            <button
              className="w-[150px] h-[40px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
              id="btn"
              onClick={updateHistoricalData}
            >
              Update
            </button>
          </div>
        </div>
        </Box>
      </Modal>
    </div>
  )
}

export const ModelReport = ({ open, handleClose, taskId }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4,
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          Work in progress.
        </Box>
      </Modal>
    </div>
  );
}
//export default Model;
